var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSalad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.99989H12.437C12.981 7.49289 13.509 6.83789 13.613 6.12589C13.819 4.38289 11.78 3.45289 10.393 4.35489C10.522 3.81889 10.548 3.25389 10.335 2.77089C9.966 1.57689 7.397 1.24689 6.557 2.30789C6.043 2.83389 5.822 3.58789 5.742 4.30189C4.505 2.72389 1.862 4.02789 1.906 5.93289C1.925 6.71489 2.375 7.45489 2.818 7.99989H1C1 10.5479 2.373 12.7749 4.413 13.9999H3V14.9999H13V13.9999H11.587C13.627 12.7749 15 10.5479 15 7.99989ZM2.904 5.90689C2.826 5.23289 3.878 4.40789 4.423 4.59789C5.135 4.78489 5.69 5.98789 5.828 6.39389L6.794 6.14489C6.682 5.52289 6.548 3.74789 7.273 3.00489C7.639 2.46089 9.283 2.60989 9.419 3.16989C9.705 3.82089 9.107 5.12389 8.662 5.79189L9.46 6.39189C9.893 5.88589 11.501 4.32789 12.397 5.33889C13.231 6.32089 11.505 7.48889 10.821 7.99889H4.187C3.745 7.60189 2.923 6.70389 2.904 5.90689ZM2.09 8.99989H13.91C12.706 15.6149 3.293 15.6109 2.091 8.99989H2.09Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSalad);
export default __webpack_public_path__ + "static/media/ico_salad.ec857ff6bf5b6be879a69294e212f2ca.svg";
export { ForwardRef as ReactComponent };